import React from "react";
import { Modal, StyleSheet, View, TouchableOpacity } from "react-native";
import CMOCustomers from "@assets/svg/CMOCustomers";
import CloseIcon from "@assets/svg/CloseIcon";
import t from "@constants/localization";
import AppText from "../../components/AppText";

const PATH = "screens/YourStore/CustomersFromCMO";

const CustomersFromCMO = ({ visible = false, onClose = () => {} }) => {
  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      transparent
      visible={visible}
      onRequestClose={onClose}
      animationType="fade"
    >
      <View style={styles.container}>
        <View style={styles.infoContainer}>
          <TouchableOpacity
            style={{ position: "absolute", right: 15, top: 15 }}
            onPress={onClose}
          >
            <CloseIcon />
          </TouchableOpacity>
          <CMOCustomers />
          <AppText
            style={{ marginVertical: 20, color: "#27AE60" }}
            fontType="head1"
            bold
          >
            {t(`${PATH}/congratulations`)}
          </AppText>
          <AppText fontType="content1">{t(`${PATH}/newFeature`)}</AppText>
          <AppText
            style={{ color: "rgba(0,0, 0, .56)", marginTop: 5 }}
            center
            fontType="content2"
          >
            {t(`${PATH}/featureDescription`)}
          </AppText>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "rgba(0,0, 0, .6)",
    justifyContent: "center",
    alignItems: "center",
    padding: 15,
  },
  infoContainer: {
    backgroundColor: "#fff",
    width: "100%",
    padding: 15,
    paddingVertical: 40,
    borderRadius: 10,
    alignItems: "center",
  },
});

export default CustomersFromCMO;
